import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var RegularBoot = createSvgIcon(React__default.createElement("path", { d: "M2 18L2 15H4L4 18C4 18.5523 4.44772 19 5 19L19 19C19.5523 19 20 18.5523 20 18L20 15H22L22 18C22 19.6569 20.6569 21 19 21L5 21C3.34315 21 2 19.6569 2 18ZM8 8H6L6 13C6 14.1046 6.89543 15 8 15L16 15C17.1046 15 18 14.1046 18 13L18 8H16V10L14 10V8L10 8L10 10H8L8 8ZM8 6L6 6H4V8V13C4 15.2091 5.79086 17 8 17L16 17C18.2091 17 20 15.2091 20 13L20 8L20 6L18 6L16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6ZM10 6L14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6Z", fillRule: "evenodd" }), 'RegularBoot');

export { RegularBoot };
